import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { OFFER_ANCHOR } from './constants';
const SHOW_AFTER = 6000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return undefined;
    let timeout = window.setTimeout(function cycle() {
      setVisible(true);
      timeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchases.length);
        timeout = window.setTimeout(cycle, HIDDEN_MS);
      }, VISIBLE_MS);
    }, SHOW_AFTER);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const purchase = purchases[index];
  return <AnimatePresence data-id="element-131" data-mp="1gydwg3ue6vl1">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-3 left-3 z-50 max-w-[calc(100vw-1.5rem)] sm:max-w-xs" role="status" aria-live="polite" data-id="element-132" data-mp="165hc2uszy76i">
          <div className="flex items-start gap-2.5 rounded-xl border-2 border-gold bg-ink-panel px-3 py-2.5 shadow-[0_0_24px_rgba(224,166,58,0.35)]" data-id="element-133" data-mp="1ax7nz57l1301">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-134" data-mp="i8a8tayo3mbi" />
            <a href={OFFER_ANCHOR} className="min-w-0" data-id="element-135" data-mp="x51axrzq7c4t">
              <p className="font-display text-[12px] font-bold uppercase leading-tight text-white" data-id="element-136" data-mp="x6m53gi4ot25">
                {purchase.name} just purchased!
              </p>
              <p className="truncate text-[11px] text-ink-text" data-id="element-137" data-mp="28jesyg7ssxcx">
                {purchase.location}, United States
              </p>
              <p className="text-[10px] font-semibold uppercase tracking-wide text-gold" data-id="element-138" data-mp="23l3ka8t8oswa">
                Speech Therapy Pro™ • a few minutes ago
              </p>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="ml-auto shrink-0 text-ink-text transition-colors hover:text-white" data-id="element-139" data-mp="2fmcvd47jfs5v">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="2pm3q9700g96h" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}